import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import confidooLogo from "../../../../assets/images/companies/confidoo.png";
import tagstreamLogo from "../../../../assets/images/companies/tagstream.png";
import rfidtunisieLogo from "../../../../assets/images/companies/rfid.png";
import { useTranslation } from "react-i18next";

const Header = ({ job }) => {
  const { t } = useTranslation();

  return (
      <React.Fragment>
        <Col lg={12}>
          <Card className="mt-n4 mx-n4">
            <div className="bg-soft-primary">
              <CardBody className="px-4 pb-4">
                <Row className="mb-3">
                  <Col className="col-md">
                    <Row className="align-items-center g-3">
                      <Col md="auto">
                        <div className="avatar-md">
                          <div className="avatar-title bg-white rounded-circle">
                            <img
                                src={
                                  job.company === "Confidoo"
                                      ? confidooLogo
                                      : job.company === "Tagstream"
                                          ? tagstreamLogo
                                          : job.company === "RFIDTunisie"
                                              ? rfidtunisieLogo
                                              : confidooLogo
                                }
                                alt={`Company logo for ${job.company}`}
                                className="avatar-sm"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col className="col-md">
                        <div>
                          <h4 className="fw-bold">{job.jobTitle}</h4>
                          <div className="hstack gap-3 flex-wrap">
                            <div>
                              <i className="ri-building-line align-bottom me-1"></i>
                              {job.company}
                            </div>
                            <div className="vr"></div>
                            <div>
                              <i className="ri-map-pin-2-line align-bottom me-1"></i>
                              {job.country}, {job.state}
                            </div>
                            <div className="vr"></div>
                            <div>
                              {t("job_overview.header.post_date")}:{" "}
                              <span className="fw-semibold">{new Date(job.datePublication).toLocaleDateString()}</span>
                            </div>
                            <div className="vr"></div>
                            <div
                                className={`badge rounded-pill bg-${
                                    job.jobType === "Full-Time"
                                        ? "success"
                                        : job.jobType === "Part-Time"
                                            ? "info"
                                            : job.jobType === "Internship"
                                                ? "warning"
                                                : "primary"
                                } fs-12`}
                            >
                              {job.jobType}
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </div>
          </Card>
        </Col>
      </React.Fragment>
  );
};

export default Header;